import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { Lock } from 'lucide-react';
export function OfferSection() {
  return <section id="offer" className="py-24 bg-sage text-white relative overflow-hidden" data-id="element-156">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-157">
        <div className="absolute -bottom-40 -right-40 w-96 h-96 bg-forest rounded-full mix-blend-multiply filter blur-3xl opacity-30" data-id="element-158"></div>
      </div>

      <div className="container mx-auto px-6 max-w-4xl relative z-10" data-id="element-159">
        <FadeIn data-id="element-160">
          <div className="bg-forest/40 backdrop-blur-sm p-8 md:p-12 rounded-3xl border border-white/10 text-center shadow-2xl" data-id="element-161">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-162">
              Recupera el control de tu metabolismo hoy mismo.
            </h2>

            <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto" data-id="element-163">
              Obtén el manual completo y todos los bonos por una fracción de lo
              que costaría una consulta privada.
            </p>

            <div className="mb-10" data-id="element-164">
              <span className="text-lg text-white/80 uppercase tracking-wider font-bold block mb-2" data-id="element-165">
                Inversión única
              </span>
              <span className="text-2xl text-white/50 line-through mr-3" data-id="element-166">
                $27.00
              </span>
              <span className="text-5xl md:text-6xl font-bold text-gold" data-id="element-167">
                $6.36 USD
              </span>
              <span className="inline-block mt-3 bg-gold/20 text-gold text-sm font-bold px-4 py-1 rounded-full uppercase tracking-wider" data-id="element-168">
                76% de descuento
              </span>
            </div>

            <Button href="https://guias-salud.com/cart/46236723511484:1" className="w-full md:w-auto px-12 py-5 text-xl mb-6" data-id="element-169">
              DESCARGAR MI MANUAL AHORA
            </Button>

            <div className="flex items-center justify-center gap-2 text-white/70 text-sm" data-id="element-170">
              <Lock className="w-4 h-4" data-id="element-171" />
              <span data-id="element-172">
                Acceso inmediato tras la compra. Pago seguro y encriptado.
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}